module.exports = __webpack_public_path__ + "img/card8.6aa9d230.png";